/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ShipmentQuotes } from "./ShipmentQuotes";
import {
  ShipmentQuotesFromJSON,
  ShipmentQuotesFromJSONTyped,
  ShipmentQuotesToJSON,
  ShipmentQuotesToJSONTyped,
} from "./ShipmentQuotes";
import type { ExperimentRun } from "./ExperimentRun";
import {
  ExperimentRunFromJSON,
  ExperimentRunFromJSONTyped,
  ExperimentRunToJSON,
  ExperimentRunToJSONTyped,
} from "./ExperimentRun";

/**
 *
 * @export
 * @interface ExperimentRunSnapshot
 */
export interface ExperimentRunSnapshot {
  /**
   *
   * @type {ExperimentRun}
   * @memberof ExperimentRunSnapshot
   */
  experimentRun?: ExperimentRun | null;
  /**
   *
   * @type {{ [key: string]: ShipmentQuotes; }}
   * @memberof ExperimentRunSnapshot
   */
  shipmentQuotes: { [key: string]: ShipmentQuotes };
  /**
   *
   * @type {string}
   * @memberof ExperimentRunSnapshot
   */
  snapshotId: string;
  /**
   *
   * @type {boolean}
   * @memberof ExperimentRunSnapshot
   */
  isInitialQuoteGroup: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ExperimentRunSnapshot
   */
  isExperimentQuoteGroup: boolean;
}

/**
 * Check if a given object implements the ExperimentRunSnapshot interface.
 */
export function instanceOfExperimentRunSnapshot(
  value: object,
): value is ExperimentRunSnapshot {
  if (!("shipmentQuotes" in value) || value["shipmentQuotes"] === undefined)
    return false;
  if (!("snapshotId" in value) || value["snapshotId"] === undefined)
    return false;
  if (
    !("isInitialQuoteGroup" in value) ||
    value["isInitialQuoteGroup"] === undefined
  )
    return false;
  if (
    !("isExperimentQuoteGroup" in value) ||
    value["isExperimentQuoteGroup"] === undefined
  )
    return false;
  return true;
}

export function ExperimentRunSnapshotFromJSON(
  json: any,
): ExperimentRunSnapshot {
  return ExperimentRunSnapshotFromJSONTyped(json, false);
}

export function ExperimentRunSnapshotFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentRunSnapshot {
  if (json == null) {
    return json;
  }
  return {
    experimentRun:
      json["experimentRun"] == null
        ? undefined
        : ExperimentRunFromJSON(json["experimentRun"]),
    shipmentQuotes: mapValues(json["shipmentQuotes"], ShipmentQuotesFromJSON),
    snapshotId: json["snapshotId"],
    isInitialQuoteGroup: json["isInitialQuoteGroup"],
    isExperimentQuoteGroup: json["isExperimentQuoteGroup"],
  };
}

export function ExperimentRunSnapshotToJSON(json: any): ExperimentRunSnapshot {
  return ExperimentRunSnapshotToJSONTyped(json, false);
}

export function ExperimentRunSnapshotToJSONTyped(
  value?: ExperimentRunSnapshot | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experimentRun: ExperimentRunToJSON(value["experimentRun"]),
    shipmentQuotes: mapValues(value["shipmentQuotes"], ShipmentQuotesToJSON),
    snapshotId: value["snapshotId"],
    isInitialQuoteGroup: value["isInitialQuoteGroup"],
    isExperimentQuoteGroup: value["isExperimentQuoteGroup"],
  };
}
